<div class="mb-6"
  [class]="isTemplate()?'w-full p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700':''">
  @if(editable()){
  <label [for]="uiId" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
    @if(isTemplate()){
    <h5 class="mb-2 text-3xl font-bold text-gray-900 dark:text-white">Altere o campo do texto
    </h5>
    } @else{
    {{placeHolder()}}{{required()?'*':''}}
    }
  </label>
  @if(isTemplate()){
  <div class="container grid grid-cols-1 md:grid-cols-3 gap-4">
    <ui-text placeHolder="Nome ou pergunta" [value]="placeHolder()" [editable]="true"
      (valueChange)="onPlaceholderChange($event)" />
    <ui-list placeHolder="Escolha o tipo do campo" [value]="type()" [choice]="textTypes" [editable]="true"
      (valueChange)="onTypeChange($event)" />
    <ui-text placeHolder="Reposta padrão" [value]="default()" [editable]="true"
      (valueChange)="onDefaultChange($event)" />
  </div>
  } @else{
  @if(inputType()=='textarea'){
  <textarea [id]="uiId" [value]="inputValue()" (input)="onChange($event.target)"
    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
    [placeholder]="placeHolder()" [required]="required()"></textarea>
  }@else{
  <div class="relative">
    <input [type]="inputType()" [attr.maxlength]="getMaxLength()" [id]="uiId" [value]="inputValue()"
      (input)="onChange($event.target)"
      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      [class]="isPassword ? 'pr-12' : ''" [placeholder]="placeHolder()" [required]="required()" />

    @if(isPassword){
    <button type="button" (click)="togglePasswordVisibility()" class="absolute top-0 right-0 bottom-0 px-3 py-2 text-sm text-gray-500 dark:text-gray-200 focus:outline-none
            transform transition-all duration-200 hover:scale-110">
      @if (isPasswordVisible) {
      <ui-icon [icon]="EIcon.Eye" [size]="EComponentSize.Large"
        [color]="!darkMode ? EAlert.DARK : EAlert.LIGHT"></ui-icon>
      }
      @if (!isPasswordVisible) {
      <ui-icon [icon]="EIcon.EyeSlash" [size]="EComponentSize.Large"
        [color]="!darkMode ? EAlert.DARK : EAlert.LIGHT"></ui-icon>
      }
    </button>
    }
  </div>

  }
  }
  }@else{
    <span class="flex flex-col gap-2 mb-2 text-sm font-medium text-gray-900 dark:text-white">
    @if(placeHolder()){
      <ui-label [tag]="ELabelTypes.CONTAINER" [clickable]="false" [type]="EAlert.DARK">
        {{placeHolder()}}
      </ui-label>
    }
    <ui-label [tag]="ELabelTypes.PARAGRAPH" [clickable]="false" [type]="EAlert.DARK">
      {{inputValue()}}
    </ui-label>
    </span>
  }
</div>